import React, { useRef, useState } from "react";
import "./TestimonialsSection.scss";
import { Row, Col, Button, Carousel, Layout } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useSlickAccessibility from "../../useSlickAccessibility";
const { Content } = Layout;

const testimonialData = [
    {
        'img': '/landingPage/hooker_1.png',
        'quote': "At Hooker, our products are crafted from meticulously sourced materials and brought to life with exceptional care and precision. Each piece reflects our unwavering commitment to quality and design excellence. As a result, the imagery we use to represent our products must meet the same exacting standards as the products themselves. All3D's AI platform has proven to be an outstanding solution for showcasing our products at the level they deserve. The platform captures intricate product details—textures, finishes, construction elements, and scale—with remarkable accuracy, surpassing the capabilities of all other AI image tools we have evaluated. The resulting imagery is consistently photorealistic, allowing our products to be presented in refined, authentic scenes that align with our brand's premium positioning. Equally impressive is the ease and precision with which images can be edited. Using simple, intuitive AI prompts, we are able to make accurate adjustments to scale, decor, lighting, and environments without compromising realism or efficiency. The All3D AI platform is easy to use and delivers exceptional visual results. All3D has become an invaluable partner in helping us visually communicate the craftsmanship, quality, and attention to detail that define Hooker Furnishings.",
        'company': 'Hooker Furniture',
        'logo':  '/landingPage/hooker_testimonial_logo.jpg',
    },
    {
        'img': '/ai_creator/img-butler.jpg',
        'quote': 'We’ve had the pleasure of working with ALL3D for over five years across several of their product services, and our latest experience with their AI imagery tool has further solidified why we continue to choose them over other vendors.',
        'name': 'Hanna O’Meara, VP Of Marketing',
        'company': 'Butler Specialty',
        'logo': '/ai_creator/logo-butler.jpg'
    },
];

const TestimonialsSection = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {

    const carouselRef = useRef(null);
    const carouselContainerRef = useRef(null);
    const [expandedQuotes, setExpandedQuotes] = useState({});

    useSlickAccessibility(carouselContainerRef);

    const next = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
    };

    const prev = () => {
        if (carouselRef.current) {
            carouselRef.current.prev();
        }
    };

    const toggleQuote = (index) => {
        setExpandedQuotes(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };


    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center testimonials-bg">
                <Col span={24} className="justify-in-center text-center mb-56">
                    <h1 className="manrope f-38 lh-46 w-600 white">Hear it from our customers</h1>
                </Col>

                <Col span={2} className="direction-flex justify-in-start">
                    <Button onClick={prev}
                        icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>

                <Col span={18}>
                    <div className="testimonial-carousel" ref={carouselContainerRef}>
                        <Carousel
                            dots={true}
                            autoplay={false}
                            ref={carouselRef}
                            style={{ width: "100%" }}>
                            {testimonialData.map((data, index) => {
                                const isExpanded = expandedQuotes[index];
                                const shouldTruncate = data.quote.length > 300;
                                
                                return (
                                    <Row className="testimonial-slide-bg" key={index}>
                                        <Col span={12} className="carousel-image-col">
                                            <img src={data.img} className="testimonial-img" alt="Customer testimonial" style={{maxWidth:'500px', maxHeight:'450px'}} />
                                        </Col>
                                        <Col span={12} className="carousel-text-col">
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                <p className={`manrope f-20 w-500 black-085 lh-28 text-left left quote ${!isExpanded && shouldTruncate ? 'quote-truncated' : ''}`} style={{"marginRight":'30px'}}>
                                                    "{isExpanded || !shouldTruncate ? data.quote : `${data.quote.substring(0, 300)}...`}"
                                                </p>
                                                {shouldTruncate && (
                                                    <Button 
                                                        type="link" 
                                                        onClick={() => toggleQuote(index)}
                                                        className="read-more-btn"
                                                        style={{padding: '0', marginLeft: '-20px'}}
                                                    >
                                                        {isExpanded ? 'Read less' : 'Read more'}
                                                    </Button>
                                                )}
                                                <p className="manrope f-14 lh-22 black-085 w-500 text-left left mb-16">– {data.name ? `${data.name}, ` : ''}{data.company}</p>
                                                <img src={data.logo} alt={data.company} style={{maxWidth:'221px', maxHeight:'60px', objectFit:'contain',marginTop:'48px',marginLeft:'-20px'}} />
                                            </div>
                                        </Col>

                                    </Row>
                                );
                            })}
                        </Carousel>
                    </div>
                </Col>
                <Col span={2} className="direction-flex justify-in-end">
                    <Button onClick={next}
                        icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {
    const [expandedQuotes, setExpandedQuotes] = useState({});
    const sliderContainerRef = useRef(null);

    useSlickAccessibility(sliderContainerRef);

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1.07,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    const toggleQuote = (index) => {
        setExpandedQuotes(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-in-center testimonials-bg">
                <Col span={24} className="justify-in-center text-center mb-32 pdlr-16">
                    <h1 className="manrope f-30 lh-46 w-600 white">Hear it from our customers</h1>
                </Col>

                <Col span={24} className="pdl-16">
                    <div ref={sliderContainerRef}>
                        <Slider {...settings} className="testimonials-card">
                            {testimonialData.map((data, index) => {
                                const isExpanded = expandedQuotes[index];
                                const shouldTruncate = data.quote.length > 200;
                                
                                return (
                                    <Row className={`testimonial-slide-bg ${index === 0 ? `first` : ``} ${isExpanded ? 'expanded' : ''}`} key={index}>
                                        <div className="box">
                                            <div className="img-setting-col">
                                                <img src={data.img} className="testimonial-img mb-16" alt="Customer testimonial" />
                                            </div>
                                            <div className="pdlr-16">
                                                <p className={`manrope f-16 w-500 black-085 lh-24 text-left mb-16 ${!isExpanded && shouldTruncate ? 'quote-truncated-mobile' : ''}`}>
                                                    "{isExpanded || !shouldTruncate ? data.quote : `${data.quote.substring(0, 200)}...`}"
                                                </p>
                                                {shouldTruncate && (
                                                    <Button 
                                                        type="link" 
                                                        onClick={() => toggleQuote(index)}
                                                        className="read-more-btn"
                                                        style={{padding: '0', marginTop: '-8px', marginBottom: '16px'}}
                                                    >
                                                        {isExpanded ? 'Read less' : 'Read more'}
                                                    </Button>
                                                )}
                                                <p className="manrope f-14 lh-22 black-085 w-500 text-left mb-16">– {data.name ? `${data.name}, ` : ''}{data.company}</p>
                                                <img src={data.logo} className="mb-16" alt={data.company} style={{maxWidth:'180px', maxHeight:'40px', objectFit:'contain'}} />
                                            </div>
                                        </div>
                                    </Row>
                                );
                            })}
                        </Slider>
                    </div>
                </Col>

            </Row>
        </Content>
    );
}


export default TestimonialsSection;
